<template>
    <div>
        <b-row>
            <b-col>
                <span class="t-title">
                    {{ $t("Reset password") }}
                </span>
            </b-col>
        </b-row>
        <b-row class="mt-4">
            <b-col>
                <b-form-input @keyup.enter="forgot_password" v-model="email" placeholder="E-mail" />
            </b-col>
        </b-row>
        <br>
        <b-row class="mt-3">
            <b-col>
                <b-button @click="resetPassword" class="bg-t-blue" block variant="primary">
                    {{ $t("Submit") }}
                </b-button>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col>
                <b-button @click="forgot_password" class="bg-t-blue" block variant="primary">
                    {{ $t("Back") }}
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    data() {
        return {
            password: '',
            email: '',
        }
    },
    methods: {
        forgot_password() {
            this.$parent.forgot_password = false
        },
        resetPassword() {
            if (this.email) {
                this.$utils.request(
                    'account/reset_password/',
                    'POST',
                    {
                        email: this.email,
                    },
                    (r) => {
                        console.log(r)
                    }
                )
            } else {
                this.$utils.customAlert(
                    'Type an valid e-mail',
                    'w'
                )
            }
        }
    }
}
</script>
